import { StyleProp } from "./StyleProp.mjs";
const DefaultVerticalAlignStyle = StyleProp.defineEnum("tldraw:verticalAlign", {
  defaultValue: "middle",
  values: ["start", "middle", "end"]
});
export {
  DefaultVerticalAlignStyle
};
//# sourceMappingURL=TLVerticalAlignStyle.mjs.map
